/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IInspectPanelHeaderInfoIconProps {
	className?: string;
}

export const InspectPanelHeaderInfoIcon: React.FC<IInspectPanelHeaderInfoIconProps> = ({
	children,
	className
}) => {
	const baseClass = BEM("edt-inspect-panel", "header-info-icon");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
